import Cookies from 'js-cookie';
import { convertToCBSupported, getClientLocale as getIntlClientLocale } from '@cbhq/intl';

function getParamLocaleOverride() {
  const safeWindow = typeof window === 'undefined' ? undefined : window;
  const params = new URLSearchParams(safeWindow?.location?.search);

  return params.get('locale');
}

function persistParamLocale() {
  const localeOverride = getParamLocaleOverride();
  if (localeOverride) {
    Cookies.set('cached_locale', localeOverride);
  }
}

export function getClientLocale(persist?: boolean) {
  const cachedLocale = Cookies.get('cached_locale');

  if (persist) {
    persistParamLocale();
  }

  // This package requires an additional look up on the `cached_locale` cookie
  // in addition to the default from `@cbhq/intl` package.
  // So here, we first check the existence of that cookie, and if doesn't exist
  // use `undefined` so that getClientLocale uses the default value.
  const localeCookieName = cachedLocale ? 'cached_locale' : undefined;

  return convertToCBSupported(getIntlClientLocale(localeCookieName));
}
